/* tslint:disable */
/* eslint-disable */
/**
 * Account App Tier Operations API
 * APIs for the Account App Tier Microservice
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountType } from './AccountType';
import {
    AccountTypeFromJSON,
    AccountTypeFromJSONTyped,
    AccountTypeToJSON,
} from './AccountType';
import type { AutoRenewalLifeCycle } from './AutoRenewalLifeCycle';
import {
    AutoRenewalLifeCycleFromJSON,
    AutoRenewalLifeCycleFromJSONTyped,
    AutoRenewalLifeCycleToJSON,
} from './AutoRenewalLifeCycle';
import type { AutoRenewalOrderStatus } from './AutoRenewalOrderStatus';
import {
    AutoRenewalOrderStatusFromJSON,
    AutoRenewalOrderStatusFromJSONTyped,
    AutoRenewalOrderStatusToJSON,
} from './AutoRenewalOrderStatus';
import type { BusinessNatureLifeCycle } from './BusinessNatureLifeCycle';
import {
    BusinessNatureLifeCycleFromJSON,
    BusinessNatureLifeCycleFromJSONTyped,
    BusinessNatureLifeCycleToJSON,
} from './BusinessNatureLifeCycle';
import type { InitialLifeCycle } from './InitialLifeCycle';
import {
    InitialLifeCycleFromJSON,
    InitialLifeCycleFromJSONTyped,
    InitialLifeCycleToJSON,
} from './InitialLifeCycle';
import type { LegalEntity } from './LegalEntity';
import {
    LegalEntityFromJSON,
    LegalEntityFromJSONTyped,
    LegalEntityToJSON,
} from './LegalEntity';
import type { Name } from './Name';
import {
    NameFromJSON,
    NameFromJSONTyped,
    NameToJSON,
} from './Name';
import type { SecondaryName } from './SecondaryName';
import {
    SecondaryNameFromJSON,
    SecondaryNameFromJSONTyped,
    SecondaryNameToJSON,
} from './SecondaryName';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface AccountDetail
 */
export interface AccountDetail {
    /**
     * 
     * @type {number}
     * @memberof AccountDetail
     */
    accountNumber?: number;
    /**
     * 
     * @type {Name}
     * @memberof AccountDetail
     */
    name: Name;
    /**
     * Secondary names for account like legal, latin, and in different character set for ex- if country has multi charset like Japan
     * @type {Array<SecondaryName>}
     * @memberof AccountDetail
     */
    secondaryNames?: Array<SecondaryName>;
    /**
     * 
     * @type {LegalEntity}
     * @memberof AccountDetail
     */
    legalEntity?: LegalEntity;
    /**
     * 
     * @type {AccountType}
     * @memberof AccountDetail
     */
    accountType: AccountType;
    /**
     * 
     * @type {Status}
     * @memberof AccountDetail
     */
    status?: Status;
    /**
     * Account language is used for legal purposes such as determining which language contracts should be signed in.
     * @type {string}
     * @memberof AccountDetail
     */
    languageCode?: string;
    /**
     * Registration defaults to Sponsor's LOA code. This can be changed later by individual or when Sponsor changed
     * @type {string}
     * @memberof AccountDetail
     */
    loaCode?: string;
    /**
     * 
     * @type {Date}
     * @memberof AccountDetail
     */
    lastRenewedDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccountDetail
     */
    entryDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccountDetail
     */
    expirationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AccountDetail
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetail
     * @deprecated
     */
    renewalFlag?: AccountDetailRenewalFlagEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountDetail
     */
    renewalStatus?: AccountDetailRenewalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountDetail
     */
    renewalLifecycle?: AccountDetailRenewalLifecycleEnum;
    /**
     * 
     * @type {BusinessNatureLifeCycle}
     * @memberof AccountDetail
     */
    businessNatureLifeCycle?: BusinessNatureLifeCycle;
    /**
     * 
     * @type {InitialLifeCycle}
     * @memberof AccountDetail
     */
    initialLifeCycle?: InitialLifeCycle;
    /**
     * 
     * @type {string}
     * @memberof AccountDetail
     */
    taxRegimen?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountDetail
     */
    taxClass?: string;
    /**
     * 
     * @type {AutoRenewalLifeCycle}
     * @memberof AccountDetail
     */
    autoRenewalLifeCycle?: AutoRenewalLifeCycle;
    /**
     * 
     * @type {AutoRenewalOrderStatus}
     * @memberof AccountDetail
     */
    autoRenewalOrderStatus?: AutoRenewalOrderStatus;
}


/**
 * @export
 */
export const AccountDetailRenewalFlagEnum = {
    AlreadyRenewed: 'ALREADY_RENEWED',
    CanRenew: 'CAN_RENEW',
    MustRenew: 'MUST_RENEW',
    CannotRenew: 'CANNOT_RENEW'
} as const;
export type AccountDetailRenewalFlagEnum = typeof AccountDetailRenewalFlagEnum[keyof typeof AccountDetailRenewalFlagEnum];

/**
 * @export
 */
export const AccountDetailRenewalStatusEnum = {
    AlreadyRenewed: 'ALREADY_RENEWED',
    CanRenew: 'CAN_RENEW',
    MustRenew: 'MUST_RENEW',
    CannotRenew: 'CANNOT_RENEW'
} as const;
export type AccountDetailRenewalStatusEnum = typeof AccountDetailRenewalStatusEnum[keyof typeof AccountDetailRenewalStatusEnum];

/**
 * @export
 */
export const AccountDetailRenewalLifecycleEnum = {
    Processing: 'PROCESSING',
    None: 'NONE',
    Completed: 'COMPLETED'
} as const;
export type AccountDetailRenewalLifecycleEnum = typeof AccountDetailRenewalLifecycleEnum[keyof typeof AccountDetailRenewalLifecycleEnum];


/**
 * Check if a given object implements the AccountDetail interface.
 */
export function instanceOfAccountDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "accountType" in value;

    return isInstance;
}

export function AccountDetailFromJSON(json: any): AccountDetail {
    return AccountDetailFromJSONTyped(json, false);
}

export function AccountDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountNumber': !exists(json, 'accountNumber') ? undefined : json['accountNumber'],
        'name': NameFromJSON(json['name']),
        'secondaryNames': !exists(json, 'secondaryNames') ? undefined : ((json['secondaryNames'] as Array<any>).map(SecondaryNameFromJSON)),
        'legalEntity': !exists(json, 'legalEntity') ? undefined : LegalEntityFromJSON(json['legalEntity']),
        'accountType': AccountTypeFromJSON(json['accountType']),
        'status': !exists(json, 'status') ? undefined : StatusFromJSON(json['status']),
        'languageCode': !exists(json, 'languageCode') ? undefined : json['languageCode'],
        'loaCode': !exists(json, 'loaCode') ? undefined : json['loaCode'],
        'lastRenewedDate': !exists(json, 'lastRenewedDate') ? undefined : (new Date(json['lastRenewedDate'])),
        'entryDate': !exists(json, 'entryDate') ? undefined : (new Date(json['entryDate'])),
        'expirationDate': !exists(json, 'expirationDate') ? undefined : (new Date(json['expirationDate'])),
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'renewalFlag': !exists(json, 'renewalFlag') ? undefined : json['renewalFlag'],
        'renewalStatus': !exists(json, 'renewalStatus') ? undefined : json['renewalStatus'],
        'renewalLifecycle': !exists(json, 'renewalLifecycle') ? undefined : json['renewalLifecycle'],
        'businessNatureLifeCycle': !exists(json, 'businessNatureLifeCycle') ? undefined : BusinessNatureLifeCycleFromJSON(json['businessNatureLifeCycle']),
        'initialLifeCycle': !exists(json, 'initialLifeCycle') ? undefined : InitialLifeCycleFromJSON(json['initialLifeCycle']),
        'taxRegimen': !exists(json, 'taxRegimen') ? undefined : json['taxRegimen'],
        'taxClass': !exists(json, 'taxClass') ? undefined : json['taxClass'],
        'autoRenewalLifeCycle': !exists(json, 'autoRenewalLifeCycle') ? undefined : AutoRenewalLifeCycleFromJSON(json['autoRenewalLifeCycle']),
        'autoRenewalOrderStatus': !exists(json, 'autoRenewalOrderStatus') ? undefined : AutoRenewalOrderStatusFromJSON(json['autoRenewalOrderStatus']),
    };
}

export function AccountDetailToJSON(value?: AccountDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountNumber': value.accountNumber,
        'name': NameToJSON(value.name),
        'secondaryNames': value.secondaryNames === undefined ? undefined : ((value.secondaryNames as Array<any>).map(SecondaryNameToJSON)),
        'legalEntity': LegalEntityToJSON(value.legalEntity),
        'accountType': AccountTypeToJSON(value.accountType),
        'status': StatusToJSON(value.status),
        'languageCode': value.languageCode,
        'loaCode': value.loaCode,
        'lastRenewedDate': value.lastRenewedDate === undefined ? undefined : (value.lastRenewedDate.toISOString()),
        'entryDate': value.entryDate === undefined ? undefined : (value.entryDate.toISOString()),
        'expirationDate': value.expirationDate === undefined ? undefined : (value.expirationDate.toISOString()),
        'countryCode': value.countryCode,
        'renewalFlag': value.renewalFlag,
        'renewalStatus': value.renewalStatus,
        'renewalLifecycle': value.renewalLifecycle,
        'businessNatureLifeCycle': BusinessNatureLifeCycleToJSON(value.businessNatureLifeCycle),
        'initialLifeCycle': InitialLifeCycleToJSON(value.initialLifeCycle),
        'taxRegimen': value.taxRegimen,
        'taxClass': value.taxClass,
        'autoRenewalLifeCycle': AutoRenewalLifeCycleToJSON(value.autoRenewalLifeCycle),
        'autoRenewalOrderStatus': AutoRenewalOrderStatusToJSON(value.autoRenewalOrderStatus),
    };
}

